import PropTypes from 'prop-types'
import React, { useState } from "react"
import MetaTags from 'react-meta-tags';
import {
  Container,
  Row,
  Col,
  Button,
  Card,
  CardBody,
  Input,
  Dropdown,
  DropdownToggle,
  DropdownItem,
  DropdownMenu
} from "reactstrap"
import { Link } from "react-router-dom"
import Util from 'pages/Dashboard/Common/Util';

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"

import moment from 'moment';

// import images
import loading from "assets/images/loading.gif";

import { useSelector } from 'react-redux';

// Charts
import LineAreaChart from "../AllCharts/apex/lineareachart";
import ChartistGraph from 'react-chartist';

import "chartist/dist/scss/chartist.scss";

import { chartResponse } from 'crud/auth.crud';
import { useEffect } from 'react';

const style = { width: '50%', fontSize: 14 };

const clickedStyle = { backgroundColor: "#48C3B1", color: "#ffffff" };

const ChartHistory = () => {
  const selector = useSelector(state => state)
  const newDate = new Date()
  const [companyId, setCompanyId] = useState(selector.auth?.user?.member_group?.[0]?.company_group.id)
  const [modalShow, setModalShow] = useState(false);
  const [reset, setReset] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [tableValue, setTableValue] = useState([]);
  const [tableValue2, setTableValue2] = useState([]);
  const [chartValue, setChartValue] = useState([]);
  const [chartValue2, setChartValue2] = useState([]);
  const [size, setSize] = useState(4);
  const [totalElements, setTotalElements] = useState(4);
  const [page, setPage] = useState(1);
  const [isRefresh, setIsRefresh] = useState(false);
  const [letDate, setLetDate] = useState(newDate);
  const [month, setMonth] = useState(moment(newDate).format("MM"));
  const [day, setDay] = useState("");
  const [dayText, setDayText] = useState("");
  const [checkedDateType, setCheckedDateType] = useState("");
  const [year, setYear] = useState(moment(newDate).format("YYYY"));
  const [findingState, setFindingState] = useState('year')

  const dayData = ['일', '월', '화', '수', '목', '금', '토']

  const lineChartData = findingState === 'year' ? {
    labels: [...chartValue.map(item => item.month)],
    series: [
      chartValue.map((item) => {
        return (item.sum)
      })
    ],
  }
    :
    {
      labels: [...chartValue2.map(item => item.x)],
      series: [
        chartValue2.map((item) => {
          return (item.y)
        })
      ],
    }
    ;
  const lineChartOptions = {
    low: 0,
    showArea: true,
  }

  const getDataList = async () => {
    setIsLoading(true)
    let date = new Date()
    let yearDate = new Date()

    let params = {
      company: companyId,
      start_ym: moment(yearDate.setFullYear(yearDate.getFullYear() - 1)).format("YYYY-MM") + '-01',
      end_ym: moment(date.setMonth(date.getMonth() + 1)).format('YYYY-MM') + '-01',
    }

    const response = await chartResponse(params);

    const content = response.data?.data || [];

    let tmpArr = []
    let tmpMonth = []
    let tmpDate = '';

    for (let i = 0; i < 12; i++) {
      tmpDate = moment(date.setMonth(date.getMonth() - 1)).format('YYYY-MM')
      tmpMonth.push(moment(date).format('MM') + '월')
      tmpArr.push(tmpDate)
    }
    let tempArr = []
    let chartArr = []
    let tmpArr2 = [0, 0, 0, 0, 0, 0, 0]
    let prevTmpArr2 = [0, 0, 0, 0, 0, 0, 0]
    for (let i = 0; i < tmpArr.length; i++) {
      let tmpSum = 0;
      for (let j = 0; j < content.length; j++) {
        const data = content[j];
        if (tmpArr[i] === moment(new Date(data.month)).format('YYYY-MM')) {
          tmpSum = data.total;
        }
      }
      let item = {
        date: tmpArr[i],
        month: tmpMonth[i],
        sum: tmpSum,
        bar: tmpSum.toString().length > 2 ? tmpSum / 10 ** ((tmpSum.toString().length - 2)) * 2 : tmpSum * 2,
        x: tmpMonth[i],
        y: tmpSum,
      }
      let items = [
        tmpArr[i],
        tmpSum,
      ]
      tempArr.push(items)
      chartArr.push(item)
    }

    for (let i = 0; i < tempArr.length; i++) {
      let val = tempArr[i]
      let tmpDiff = val[1] - (tempArr[i + 1]?.[1] || 0)
      val.push(tmpDiff)
      val.push(parseInt(val[1] * 0.01))
    }
    tempArr = tempArr.filter(itm => itm[0] + '-01' !== params.start_ym)
    chartArr = chartArr.filter(itm => itm.date + '-01' !== params.start_ym)
    chartArr.reverse()

    let tempArr2 = []
    let chartArr2 = []
    let weekData = response.data?.week || [];
    let prevWeekData = response.data?.prev_week || [];
    for (let i = 0; i < tmpArr2.length; i++) {
      let val = weekData.filter(itm => itm.day - 1 === i)?.[0]
      tmpArr2[i] = val?.qty_sum || 0
      let prev_val = prevWeekData.filter(itm => itm.day - 1 === i)?.[0]
      prevTmpArr2[i] = prev_val?.qty_sum || 0
      let items = [
        dayData[i],
        tmpArr2[i],
        tmpArr2[i] - prevTmpArr2[i],
        parseInt(tmpArr2[i] * 0.15),
      ]
      tempArr2.push(items)
      let itm = {
        x: dayData[i],
        y: tmpArr2[i]
      }
      chartArr2.push(itm)
    }

    setTableValue(tempArr)
    setChartValue(chartArr)
    setChartValue2(chartArr2)
    setTableValue2(tempArr2)
    setIsLoading(false)
  }

  useEffect(() => {
    getDataList();
  }, [])

  useEffect(() => {
    if (isRefresh) {
      setIsRefresh(false)
      // getDataList();
    }
  }, [isRefresh])

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>차트 | 웨이스트버스</title>
        </MetaTags>
        <Container fluid>
          <Breadcrumbs maintitle="Home" title="관리대장" breadcrumbItem="차트" />
          <div className="btn-group" style={{ margin: "0 auto 24px", height: 38 }}>
            <Button
              type="button"
              size="sm"
              className={findingState == 'year' ? 'waves-effect custom-btn active' : 'custom-btn waves-effect'}
              onClick={() => {
                setFindingState('year')
              }}
            >
              월별 배출량 차트
            </Button>
            <Button
              type="button"
              size="sm"
              className={findingState == 'month' ? 'waves-effect custom-btn active' : 'custom-btn waves-effect'}
              onClick={() => {
                setFindingState('month')
              }}
            >
              요일별 배출량 차트
            </Button>
          </div>
          <Row>
            <Col xl={12} style={{ maxWidth: 1065 }}>
              <Card>
                <CardBody>
                  <Row style={{ borderRadius: '4px' }}>
                    <Col lg={12} style={{ margin: "24px auto" }}>
                      <div>
                        <ChartistGraph data={lineChartData} style={{ height: "300px" }} options={lineChartOptions} type={'Bar'} />
                      </div>
                    </Col>
                  </Row>
                </CardBody>
                {isLoading && <div style={{
                  position: "absolute",
                  width: '100%',
                  height: '100%',
                  top: 0,
                  left: 0,
                  background: 'rgba(255, 255, 255, 0.6)',
                  zIndex: 999,
                  display: "flex",
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}>
                  <img src={loading} alt="로딩중입니다." width={'5%'}></img>
                </div>}
              </Card>
            </Col>

          </Row>
          <Row>
            <Col xl={12} style={{ maxWidth: 1065 }}>
              <Card style={{ borderRadius: '4px', overflow: 'hidden' }}>
                <CardBody style={{ padding: 0 }}>
                  <Row style={{ margin: 0 }}>
                    <Col lg={12} style={{ padding: 0 }}>
                      <Row style={{ margin: 0 }}>
                        <table className='chart-table'>
                          <thead className='chart-thead'>
                            <tr>
                              <td>{findingState === 'year' ? '년/월' : '요일'}</td>
                              <td>배출량(kg)</td>
                              <td>증감</td>
                              <td>CO₂배출량</td>
                            </tr>
                          </thead>
                          <tbody className='chart-tbody'>
                            {findingState === 'year' && tableValue.map((item, index) => {
                              return (
                                <tr key={index}>
                                  <td>{item[0]}</td>
                                  <td>{Util.setPrice(item[1])}</td>
                                  <td style={{ color: item[2] < 0 ? 'red' : 'blue' }}>{item[2] <= 0 ? Util.setPrice(item[2]) : '+' + Util.setPrice(item[2])}</td>
                                  <td >{Util.setPrice(item[3])}</td>
                                </tr>
                              )
                            })}
                            {findingState === 'month' && tableValue2.map((item, index) => {
                              return (
                                <tr key={index}>
                                  <td>{item[0]}</td>
                                  <td>{Util.setPrice(item[1])}</td>
                                  <td style={{ color: item[2] < 0 ? 'red' : 'blue' }}>{item[2] <= 0 ? Util.setPrice(item[2]) : '+' + Util.setPrice(item[2])}</td>
                                  <td >{Util.setPrice(item[3])}</td>
                                </tr>
                              )
                            })}
                          </tbody>
                        </table>
                      </Row>
                    </Col>
                  </Row>
                </CardBody>
                {isLoading && <div style={{
                  position: "absolute",
                  width: '100%',
                  height: '100%',
                  top: 0,
                  left: 0,
                  background: 'rgba(255, 255, 255, 0.6)',
                  zIndex: 999,
                  display: "flex",
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}>
                  <img src={loading} alt="로딩중입니다." width={'5%'}></img>
                </div>}
              </Card>
            </Col>

          </Row>
        </Container>
      </div>

    </React.Fragment>
  )
}

export default ChartHistory
